import DefaultProps from '../../commonTypes/defaultprops.types';
import COLORS from '../../style/universal.color';
const {
  mlbGrey7,
  skeletonLightMain,
  skeletonLightHighlight,
  skeletonDarkHighlight
} = COLORS;

export interface SkeletonProps extends DefaultProps {
  height?: string | number;
  width?: string | number;
  borderRadius?: string | number;
  isCircle?: boolean;
  animation?: boolean;
  margin?: string | number;
  count?: number;
}

export interface IndividualStyle {
  main: string;
  highlight: string;
}

interface SkeletonColorsMap {
  primary: IndividualStyle;
  dark: IndividualStyle;
}

export const SkeletonColors: SkeletonColorsMap = {
  primary: {
    main: skeletonLightMain,
    highlight: skeletonLightHighlight
  },
  dark: {
    main: mlbGrey7,
    highlight: skeletonDarkHighlight
  }
};
